import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { openWhatsApp } from "@/data/content";

const WhatsAppWidget = () => {
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowBubble(true), 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {showBubble && (
        <div
          data-testid="whatsapp-bubble"
          className="relative bg-white rounded-2xl shadow-2xl px-5 py-4 max-w-[230px] animate-[fadeIn_0.4s_ease]"
        >
          <button
            data-testid="whatsapp-bubble-close"
            onClick={() => setShowBubble(false)}
            className="absolute top-2 right-2 text-slate-400 hover:text-slate-600"
          >
            <X className="w-4 h-4" />
          </button>
          <p className="font-bold text-[#0f1733]">Precisa de gás? 🔥</p>
          <p className="text-slate-500 text-sm mt-1">Fale conosco pelo WhatsApp!</p>
        </div>
      )}

      <button
        data-testid="whatsapp-float-btn"
        onClick={() => openWhatsApp()}
        aria-label="Falar no WhatsApp"
        className="w-16 h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-xl flex items-center justify-center transition-all hover:scale-105"
      >
        <MessageCircle className="w-8 h-8 text-white" fill="white" />
      </button>
    </div>
  );
};

export default WhatsAppWidget;
